import {apiAuth} from "./configUrl.jsx"

export async function getUser(token) {
  // console.warn(token)
  try {
    const response = await fetch(apiAuth, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, 
      }
    });
    const data = await response.json();
    // console.warn(data)
    if (response.ok && data) { return data;} 
    else { return false;}
  } 
  catch { return false;}
}